export default "/bundles/assets/photo1_6d881d107b16070fc5b8c99db4aa608a.png";